import * as yup from "yup";

const LIQUID_VARIABLE_PATTERN = /\{\{[^}]{0,255}\}\}/g;

// The only variable that resolves to a URL, so the only one valid as a bare link.
// Mirrors the backend Tiptap::Liquid::BROADCAST_URL_VARIABLES.
const BROADCAST_URL_VARIABLES: readonly string[] = ["community.url"];

export const containsLiquidVariable = (value: string) => value.includes("{{");

const bareVariableName = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("{{") || !trimmed.endsWith("}}")) return null;

  const inner = trimmed.slice(2, -2);
  if (inner.includes("{{") || inner.includes("}}")) return null;

  return inner.split("|")[0].trim();
};

export const isBareLiquidVariable = (value: string) =>
  bareVariableName(value) !== null;

export const isValidUrlWithVariables = (value: string) => {
  const bareName = bareVariableName(value);
  if (bareName !== null) return BROADCAST_URL_VARIABLES.includes(bareName);

  return yup
    .string()
    .url()
    .isValidSync(value.replace(LIQUID_VARIABLE_PATTERN, "0"));
};
